import styled from 'styled-components';

export const StyledAffix = styled.div<{ offsetTop?: string; affix?: boolean }>`
  top: ${({ offsetTop }) => (offsetTop ? offsetTop : 0)};
  z-index: 998;
  width: 100vw;
  position: ${({ affix }) => (affix ? 'fixed' : 'inherit')};
`;

export const AffixMask = styled.div<{
  height: number;
  visible: boolean;
}>`
  width: 100%;
  height: ${({ height }) => `${height}px`};
  display: ${({ visible }) => (visible ? 'block' : 'none')};
`;
